export enum TipoCargosChapa {
  Desconhecido = 'DESCONHECIDO',
  Presidente = 'PRESIDENTE',
  Vice_Presidente = 'VICE_PRESIDENTE',
  Conselheiro = 'CONSELHEIRO',
  Conselheiro_Efetivo = 'CONSELHEIRO_EFETIVO',
  Conselheiro_Suplente = 'CONSELHEIRO_SUPLENTE',
}
